<template>
  <b-container :class="[$style.wrapper, { 'pt-4': isSmallScreen() }]" fluid>
    <b-row :class="$style.footerLinks">
      <b-col md="12" lg="3" :class="$style.appBadgeCol">
        <a
          href="https://apps.apple.com/app/id1265681648"
          target="_blank"
          :class="$style.appBadgeLink"
        >
          <img
            src="@assets/images/app-store.png"
            :class="$style.appBadge"
            alt="Apple app store icon and badge"
          />
        </a>
      </b-col>
      <b-col md="12" lg="3" :class="$style.appBadgeCol">
        <a
          href="https://play.google.com/store/apps/details?id=com.roaringsky.shoponcampus"
          target="_blank"
          :class="$style.appBadgeLink"
        >
          <img
            src="@assets/images/google-play.png"
            :class="$style.appBadge"
            alt="Google play store icon and badge"
          />
        </a>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row :class="[$style.termsAndConditions, { 'py-4': isSmallScreen() }]">
      <b-col>
        <div class="inner">
          <!-- <router-link
            :to="{ name: 'contact', params: { site: site.slug } }"
            :class="$style.footerLink"
          >
            Contact Us
          </router-link> -->
          <!-- <br /> -->
          <!-- <router-link
            :to="{ name: 'refund-policy', params: { site: site.slug } }"
            :class="$style.footerLink"
          >
            Refund Policy
          </router-link> -->
          <br />
          <a :href="`/${site.slug}/privacy-policy`" :class="$style.footerLink">
            Privacy Policy
          </a>
          /
          <a :href="`/${site.slug}/terms-of-use`" :class="$style.footerLink">
            Terms of Use
          </a>
          <br />
          <a
            :href="
              `https://privacyportal-eu-cdn.onetrust.com/dsarwebform/8394ad8c-2b46-4837-8771-cbc69779a644/31bea1f4-92c3-440b-be0e-468af4f4b1f3.html?Source=${site.name}`
            "
            :class="$style.footerLink"
            target="_blank"
          >
            Privacy Request
          </a>
          <br />
          <br />
          <span>
            Provided by RoaringSky inc / All Rights Reserved
          </span>
          <br v-if="isSmallScreen() === false" />
          &copy; {{ new Date().getFullYear() }}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loadedSuccessfully: false,
    }
  },

  computed: {
    ...mapGetters({
      site: 'sites/getSite',
    }),
  },

  methods: {
    isSmallScreen() {
      let small = false
      if (this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
        small = true
      }
      return small
    },
  },
}
</script>

<style module>
.appBadgeCol {
  text-align: center;
}
.appBadge {
  width: 175px;
}
.appBadge:focus {
  overflow: none !important;
}
.appBadgeLink:focus {
  overflow: visible !important;
}
.footerLink,
.footerLink:visited {
  font-size: 14px;
  color: #f7f7f7;
}
.footerLink:hover {
  color: #f7f7f7;
}
.footerLinks {
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.wrapper {
  color: #f7f7f7;
  background-color: #686868;
}
.termsAndConditions {
  font-size: 14px;
  text-align: center;
}

@media (min-width: 992px) {
  .wrapper {
    padding: 1.5rem 5rem;
    margin: 3.125rem 0 0;
  }
}
</style>
